/*
  cstrap-form4.js — Strap Form V1 = 4 O VUONG (09/10/2026 00:46, chu shop, phuong an A).
  Nap boi sections/custom-strap-form.liquid. O that van la <select name="properties[Strap form]"> (an bang CSS) — engine,
  preview 2D, Thickness, kiem bat buoc va gio hang doc select nhu cu. File nay chi:
    - bam o vuong -> dat gia tri select + ban 'change' (moi thu khac chay theo nhu khach chon dropdown);
    - select doi tu bat ky dau (prefill, link ?form=, engine) -> to dam o tuong ung (aria-pressed).
*/
(function () {
  if (window.__cstrapForm4) return;
  window.__cstrapForm4 = 1;

  function selCua(khung) {
    var f = khung.closest('.cfield');
    return f && f.querySelector('select[name="properties[Strap form]"]');
  }
  function ve(khung) {
    var sel = selCua(khung); if (!sel) return;
    khung.querySelectorAll('.cform4__o').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-v') === sel.value ? 'true' : 'false');
    });
  }
  function veHet() { document.querySelectorAll('[data-form4]').forEach(ve); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cform4__o');
    if (!b) return;
    var khung = b.closest('[data-form4]'), sel = khung && selCua(khung);
    if (!sel) return;
    var v = b.getAttribute('data-v');
    if (sel.value !== v) {
      sel.value = v;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    ve(khung);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'properties[Strap form]' && t.tagName === 'SELECT') {
      var khung = t.closest('.cfield') && t.closest('.cfield').querySelector('[data-form4]');
      if (khung) ve(khung);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', veHet); else veHet();
  window.addEventListener('load', veHet);
})();
